require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/ng-admin/~/angular/index.js
// module id = 590
// module chunks = 1